/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OasisAssessmenValuesViewModel } from './OasisAssessmenValuesViewModel'; 

export function getOasisAssessmentValuesOptions(id: string, onSuccess?: (result: OasisAssessmenValuesViewModel) => void) {
	return queryOptions({
		queryKey: ['oasis-assessment-values', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/oasis/queries/getoasisassessmentvalues/' + id;
			const resp = await axios.get<OasisAssessmenValuesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}